import React from "react"
export default function PenaltyPagination({ page, total, change, name }) {
  return <nav className="penalty-pagination" aria-label={name + " pagination"}>
    <span>{total} {name} · Page {page} of {Math.max(1, Math.ceil(total / 10))}</span>
    <button className="btn btn-light btn-sm" disabled={page === 1} onClick={() => change(page - 1)} aria-label={"Previous " + name}>Previous</button>
    <button className="btn btn-light btn-sm" disabled={page * 10 >= total} onClick={() => change(page + 1)} aria-label={"Next " + name}>Next</button>
  </nav>
}
